export const getDecodedID = (id: string) => atob(id);
export const getDecodedBudgetId = (id: string) => getDecodedID(id).split(":")[1];

export const getEncodedID = (id: string) => btoa(id);

export const getEncodedBudgetId = (id: number) => getEncodedID(`Budget:${id}`);
export const getEncodedProposalId = (budgetId: number, id: number) => getEncodedID(`Proposal:[${budgetId},${id}]`);
export const getEncodedWorksheetId = (budgetId: number, proposalId: number, id: number) =>
  getEncodedID(`Operation:[${budgetId},${proposalId},${id}]`);
